// extracted by mini-css-extract-plugin
export default {"ribbon":"VendorRibbon_ribbon__yHkhJ","tab":"VendorRibbon_tab__DQLJV","active":"VendorRibbon_active__ef-5Z"};